import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { isValidStored } from '../_helpers/storage.util';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {
    window.scroll(0,0);

  }

  private getLoginDetail(): any {
    try {
      return JSON.parse(localStorage.getItem('grw_login') || '{}');
    } catch (e) {
      return {};
    }
  }

  private isCreateContentRoute(url: string): boolean {
    return [
      '/create-post',
      '/create-posts',
      '/create-albums',
      '/create-program'
    ].includes(url);
  }

  private canCreateContent(): boolean {
    if (environment.bypassProfileCheck ?? false) {
      return true;
    }

    const loginDetail = this.getLoginDetail();
    return Boolean(
      loginDetail.profile_complete === true &&
      loginDetail.stripe_account_verify === true &&
      loginDetail.subscription_added === true
    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      var mm:any =(state.url).split('/');
      var url :any = '/'+ mm[1];
      if(url.includes('?')){
        var s:any=url.split('?');
        url=s[0];
      }
      let loginStatus: boolean = false;
      if (isValidStored('grw_login')) {
        loginStatus = true;
      } 
      if (url === '/' || url === '/signup' || url === '/signin' || url === '/forgot-password' || url === '/reset-password' || url === '/verify-email'  || url === '/verify-email-mobile') {
        if (loginStatus) {
          this.router.navigate(['/dashboard']);
          return false;
        }
      } else {
        if (!loginStatus) {
          this.router.navigate(['/signin']);
          return false;
        }

        if (this.isCreateContentRoute(url) && !this.canCreateContent()) {
          this.router.navigate(['/profile']);
          return false;
        }
      }
      window.scroll(0,0);
    return true;
  }

}
